<!-- prettier-ignore -->

@if (item()?.type == 'point' || item()?.type == 'event'){
    <div class="timeline-card timeline-card__item" [ngClass]="{'timeline-card__error': item()?.status == 'ko'}" [ngStyle]="{'min-height': marginSizeCards?.[item()?.point?.size] + 'px'}"> 
        <img (click)="removeItem(item())" class="remove-icon" src="/assets/imgs/remove.svg" />
        <div (click)="showItemInfo(item()?.point)" class="wrapper">
            @if (item()?.status == 'ko'){
                <div class="background-error"></div>
            }
            <div class="time">
                <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 6L12 12L18 12" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                {{item()?.point?.durationc}}
            </div> 
            <div class="card-image-wrapper">
                <img [src]="item()?.point?.cover_image" (error)="tools.onImageError($event)" style="width: 100%; height: 100%; object-fit: cover;">
            </div>
            <div class="card-text-wrapper" [ngClass]="{'card-text-wrapper__error': item()?.status == 'ko'}">
                <span class="card-text" [ngClass]="{'card-text__error': item()?.status == 'ko'}">{{item()?.point?.name?.[translate.currentLang]}}</span>
            </div>
        </div>
    </div>
}

@if (item()?.type == 'add'){
    <div class="timeline-card timeline-card__add-item" [ngStyle]="{ 'border': '4px dashed ' + color() }">
        <span class="plus-icon" [ngStyle]="{'color': color()}">+</span>
    </div>
}